<template>
  <div>
    <div class="panel" v-if="items.length > 0">
      <card-rect
        v-for="item of items"
        :key="item.id"
        :item="item"
        :active="activeIndex"
        @cardclick="onCardClick"
      ></card-rect>
    </div>
    <div v-else class="no-found">No locations found...</div>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import _ from "lodash";
import CardRect from "./CardRect";
export default {
  name: "card-rect-panel",
  components: {
    CardRect
  },
  props: {
    category: {
      type: [Number],
      default: -1
    }
  },
  data: () => ({
    items: [],
    activeIndex: -1
  }),
  created() {
    this.getLocations();
  },
  methods: {
    getLocations() {
      axios.get(`/categories/${this.category}/locations`).then(response => {
        this.items = response.data.data;
      });
    },
    onCardClick(id) {
      this.activeIndex = id;
      var name = _.find(this.items, { id }).name;
      this.$emit("location", { id, name });
    }
  }
};
</script>

<style lang="scss" scoped>
.no-found {
  padding: 20px 0 30px;
  color: $gray-500;
}
</style>
